export const extractVersionNumber = (str: string) => {
  const regex = /\d+/; // regular expression to match digits
  const match = str.match(regex); // search for first occurrence of digits
  if (match) {
    return match[0]; // convert matched digits to a string
  } else {
    return null; // return null if no digits found in string
  }
};
